import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import {
    FolderType,
    IFolder,
} from '@models';

@Component({
    selector: 'ui-folder-tree-breadcrumbs',
    templateUrl: './ui-folder-tree-breadcrumbs.component.html',
    styleUrls: ['./ui-folder-tree-breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiFolderTreeBreadCrumbsComponent {
    @Input()
    public showFolderIcon = false;

    @Input()
    public folder?: IFolder;

    public readonly FolderType = FolderType;

    public get parentsTooltip() {
        return this.parentNames.join(' / ') + ' /';
    }

    public get parentNames() {
        if (!this.folder) {
            return [];
        }
        return this.folder.fullyQualifiedName.split('/').slice(0, -1);
    }
}
